const React = require('react');
const { Title } = require('@andes-landings/title');
const ComponentText = require('./componentText');
const DontCode = require('./images/image');
const Predesign = require('./images/predesign');
const AdvancedCustomization = require('./images/advancedCustomization');
const { getSite } = require('../../../../../utils/location');

const OnlinePayments = ({ i18n, lang, siteId, brand }) => {
  const location = getSite(siteId);
  const isMLB = siteId === 'MLB';

  const linkPayment = isMLB ? `https://www.mercadopago${location}/ferramentas-para-vender/link-de-pagamento` : `https://www.mercadopago${location}/herramientas-para-vender/link-de-pago`;
  const linkSubscriptionPlan = `/developers/${lang}/docs/subscription-plans/landing`;
  const choAPi = isMLB ? i18n.gettext('CHECKOUT TRANSPARENTE') : i18n.gettext('CHECKOUT API');
  const choAPItrack = isMLB ? i18n.gettext('Documentación Checkout Transparente') : i18n.gettext('Documentación Checkout API');
  const bulletAPI = isMLB ? i18n.gettext('Combina módulos de Checkout Transparente.') : i18n.gettext('Combina módulos prediseñados de Checkout API.');

  const getLocalizedImage = (images, brandName, langName) => {
    if (brandName === 'yellowblue-light') {
      return images[`re-${langName}`] || images[langName];
    }
    return images[langName];
  };

  const AdvancedCustomizationImage = getLocalizedImage(AdvancedCustomization, brand, lang);
  const DontCodeImage = getLocalizedImage(DontCode, brand, lang);
  const PredesingImage = getLocalizedImage(Predesign, brand, lang);

  const data = [
    { titleObject: i18n.gettext('Disponible sin código'),
      image: <DontCodeImage />,
      ComponentsTexts: [
        { pillText: i18n.gettext('LINK DE PAGO'), title: i18n.gettext('Cobro con enlace o botón'), bullets: [i18n.gettext('Crea un link para redes sociales o un botón en tu sitio.'), i18n.gettext('Gestiona tus ventas con tu cuenta de Mercado Pago.')], link: linkPayment, track: 'payment-link', label: i18n.gettext('Documentación Link de pago') },
        { pillText: i18n.gettext('PLANES DE SUSCRIPCIÓN'), title: i18n.gettext('Cobros recurrentes sin integración'), bullets: [i18n.gettext('Administra pagos periódicos de forma simple.'), i18n.gettext('Permite a los clientes pagar sin necesitar un sitio.')], link: linkSubscriptionPlan, track: 'subscription-plan', label: i18n.gettext('Documentación Planes de suscripción') },
      ],
    },
    { titleObject: i18n.gettext('Modelos prediseñados'),
      image: <PredesingImage />,
      ComponentsTexts: [
        { pillText: i18n.gettext('CHECKOUT PRO'), title: i18n.gettext('Listo para configurar'), bullets: [i18n.gettext('Brinda todos los medios de pago con fácil integración.'), i18n.gettext('Redirige a los clientes a pagar con Mercado Pago.')], link: `/developers/${lang}/docs/checkout-pro/overview`, track: 'checkout-pro', label: choAPItrack },
        { pillText: i18n.gettext('CHECKOUT BRICKS'), title: i18n.gettext('Módulos para armar'), bullets: [i18n.gettext('Ensambla la experiencia con tu marca y en tu sitio.'), bulletAPI], link: `/developers/${lang}/docs/checkout-bricks/landing`, track: 'checkout-bricks', label: i18n.gettext('Documentación Checkout Bricks') },
      ],
    },
    { titleObject: i18n.gettext('Personalización avanzada'),
      image: <AdvancedCustomizationImage />,
      ComponentsTexts: [
        { pillText: choAPi, title: i18n.gettext('Control total'), bullets: [i18n.gettext('Diseña todo el proceso de pago sin salir de tu sitio.'), i18n.gettext('Logra una experiencia 100% a la medida de tu marca.')], link: `/developers/${lang}/docs/checkout-api/landing`, track: 'checkout-api', label: i18n.gettext('Documentación Checkout API') },
        { pillText: i18n.gettext('SUSCRIPCIONES'), title: i18n.gettext('Cobros recurrentes con integración'), bullets: [i18n.gettext('Automatiza con versatilidad pagos periódicos.'), i18n.gettext('Requiere conocimiento experto en programación.')], link: `/developers/${lang}/docs/subscriptions/landing`, track: 'suscription', label: i18n.gettext('Documentación Suscripciones') },
      ],
    },
  ];

  return (
    <div className="online-content-container" id="online-payments">
      <Title
        className="online-content-title"
        title={i18n.gettext('Guía para cobro online')}
        description={i18n.gettext('Recursos para quienes venden en línea en un sitio propio, por redes sociales o por medio de una plataforma.')}
        isHero
        align="center"
        />
      <h1 className="online-content-sub-title">{i18n.gettext('Integra nuestras soluciones para sitios propios y redes sociales')}</h1>
      <div className="online-text-container" id="online-content-container">
        {data.map((item) => (
          <div className="online-text-section">
            <div>
              {item.image}
              <h2 className="online-text-section-title">{item.titleObject}</h2>
            </div>
            <div>
              {item?.ComponentsTexts.map((componentText) => (
                <ComponentText pillText={componentText.pillText} title={componentText.title} bullets={componentText.bullets} link={componentText.link} track={componentText.track} lang={lang} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

module.exports = OnlinePayments;
